"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidSpotifyLink = exports.isSupportedSocial = void 0;
const enums_1 = require("../enums");
const isSupportedSocial = (key) => Object.values(enums_1.ALL_SOCIALS).includes(key);
exports.isSupportedSocial = isSupportedSocial;
const isValidSpotifyLink = (key) => ['artist', 'user', 'track', 'playlist'].includes(key);
exports.isValidSpotifyLink = isValidSpotifyLink;
//# sourceMappingURL=socials.js.map